import { z } from "zod";

export const preferredCleanerUserIdSchema = z.string().regex(/^[0-9a-f]{32}$/u);

export const preferredCleanerSchema = z.strictObject({
  cleanerUserId: preferredCleanerUserIdSchema,
  rankNo: z.number().int().min(1).max(20),
  publicName: z.string().nullable(),
});

export const preferredCleanerListResponseSchema = z.strictObject({
  status: z.literal("ok"),
  cleaners: z.array(preferredCleanerSchema),
});

export const replacePreferredCleanersInputSchema = z.strictObject({
  cleanerUserIds: z.array(preferredCleanerUserIdSchema).min(1).max(20),
});

export const replacePreferredCleanersResponseSchema = z.strictObject({
  status: z.enum(["updated", "unchanged"]),
  cleaners: z.array(preferredCleanerSchema),
});

export type PreferredCleaner = z.infer<typeof preferredCleanerSchema>;
export type ReplacePreferredCleanersInput = z.infer<typeof replacePreferredCleanersInputSchema>;
